exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/video-link-upload-modal/video-link-upload-modal.component.css
// module id = ../../../../../src/app/shared/video-link-upload-modal/video-link-upload-modal.component.css
// module chunks = main